<template>
    <div class="add-new-client">
        <md-dialog :md-active.sync="showDialog" >
         
            <md-dialog-title>
                <span>Do you approve the creatives you did not leave any comments on?</span>
                <button class="btn btn--close" @click="cancel"></button>
            </md-dialog-title>
            
            <md-dialog-actions>
              <div class="md-layout">
                <div class="md-layout-item">
                  <md-button class="md-primary modal-cancel-btn" @click="cancel">No</md-button>
                </div>
                <div class="md-layout-item text-right">
                 <md-button class="md-primary modal-save-btn" @click="approveUncommented" >Yes</md-button>
                </div>
              </div>
            </md-dialog-actions>
            
        </md-dialog>
            
        
    </div>
</template>
<script>
export default {
    props:['showDialog'],
    methods: {
        cancel(){
            this.$parent.showApproveUncommented = false;
        },
        approveUncommented(){
            this.$parent.showApproveUncommented = false;
            this.$parent.approveAllUncommented = true;
            this.$parent.sendToAccount();
        }
    }
}
</script>

